import firebase from 'firebase/app';
import 'firebase/firestore';

var firebaseConfig = {
    apiKey: "AIzaSyCAdvs1jlVU9vO-mV3i11li2vSZgZYql9k",
    authDomain: "akoad-abd4f.firebaseapp.com",
    databaseURL: "https://akoad-abd4f.firebaseio.com",
    projectId: "akoad-abd4f",
    storageBucket: "akoad-abd4f.appspot.com",
    messagingSenderId: "492725697980",
    appId: "1:492725697980:web:74bc74e1bd73c5d2b53fb9",
    measurementId: "G-G2PEFRK60C"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
//   firebase.analytics();

  
export const f = firebase;
export const db = firebase.firestore();
// export const auth = firebase.auth();
// export const storage = firebase.storage();